import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';

@Component({
    selector: 'app-general',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './general.component.html',
    styleUrl: './general.component.scss'
})
export class GeneralComponent {
    // Accept either discrete inputs or a placement object
    @Input() placement: any | null = null;
    @Input() flockNo: string | null = null;
    @Input() supplier: string | null = null;
    @Input() farmName: string | null = null;
    @Input() houses: string[] | null = null;
    @Input() partitions: string[] | null = null;
    @Input() placementDateTime: string | Date | null = null;
    @Input() expectedStartSellingDate: string | Date | null = null;
    @Input() expectedEndSellingDate: string | Date | null = null;

    // Helper to render arrays or list of objects as comma-separated string
    join(list: any[] | null | undefined, key?: string): string {
        if (!list || !Array.isArray(list) || list.length === 0) return '';
        if (key) {
            return list
                .map((it: any) => (it && it[key]) ?? '')
                .filter(Boolean)
                .join(', ');
        }
        return (list as any[]).join(', ');
    }
}
